export const DOCS_PERMISSION = "docs_read";

/**
 * Apps whose documentation the user may read, sorted by name.
 * @param {Array<{id: string, name: string}> | undefined} apps
 * @param {(policy: string, appId: string) => boolean} isAuthorized
 */
export function getDocsApps(apps, isAuthorized) {
  return (apps ?? [])
    .filter((app) => isAuthorized(DOCS_PERMISSION, app.id))
    .sort((first, second) => first.name.localeCompare(second.name));
}

/**
 * URL of an app's docs site, `{apiUrl}/{appId}/docs/?theme=…&lang=…`.
 * @param {string} apiUrl
 * @param {string} appId
 * @param {{theme: string, lang: string}} settings
 */
export function buildDocsUrl(apiUrl, appId, { theme, lang }) {
  const base = apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`;
  const url = new URL(`${encodeURIComponent(appId)}/docs/`, base);

  url.searchParams.set("theme", theme);
  url.searchParams.set("lang", lang);

  return url.toString();
}
